import React from "react";

export const DefaultTermsAndConditionEn = (
  <div>
    <div style={{ paddingRight: "8px" }}>
      <div style={{ marginTop: "8px" }}>
        <h2 style={{ textAlign: "center" }}>
          Terms and conditions of the Nemuru Platform
        </h2>
        <h3 style={{ marginTop: "0px" }}>
          <strong>
            Please read these terms and conditions ("T&C" or "Terms and
            Conditions") carefully before accepting them or using the Nemuru
            Platform or Services.
          </strong>
        </h3>
      </div>
    </div>
    <p>
      These Terms and Conditions constitute a binding agreement between (i)
      Nemuru Digital, S.L. (hereinafter, &nbsp;
      <strong>"Nemuru"</strong> or the &nbsp;
      <strong>"Company"</strong>), an entity constituted in accordance with
      Spanish law, domiciled at Edificio Palau de Mar, Plaza Pau Vila, number 1,
      1st floor, sector AD, office 1AD, Barcelona, with NIF B-67.183.574,
      registered in the Commercial Registry of Barcelona, in volume 46.381,
      folio 118, and sheet B-518.127, and in the State Registry of Financial
      Intermediaries with number 873/2018 of section 2; and (ii) the user who
      uses the Platform and/or benefits from the Services provided by Nemuru
      (the <strong>"User"</strong> and, together with Nemuru, the{" "}
      <strong>"Parties"</strong>).
    </p>
    <p>
      By accepting these T&C and using the Nemuru Platform, the User represents
      and warrants to Nemuru (i) that the T&C are being formalized or accepted
      in their own name and representation (if an individual) or in the name and
      representation of the User (if a legal entity), and, in the latter case,
      that they have sufficient capacity to bind and accept these T&C in the
      name and representation of the User; (ii) that they are of legal age and
      have the sufficient legal capacity to accept these T&C (if an individual);
      and (iii) to know and accept these T&C, including Nemuru's
      <a href="https://nemuru.com/privacidad-intermediacion" target="_blank">
        privacy policy
      </a>{" "}
      (the&nbsp;
      <strong>"Privacy Policy"</strong>) and
      <a href="https://nemuru.com/privacidad-intermediacion" target="_blank">
        cookie policy
      </a>{" "}
      (the &nbsp;
      <strong>"Cookie Policy"</strong>), which are incorporated into these T&C
      by reference. If you do not agree with or do not wish to accept the above
      documents, you should not access the Platform or benefit from the Services
      provided by Nemuru through it.
    </p>
    <ol>
      <li>
        <h3>
          <strong>Purpose</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Purpose: </strong>
            </h4>
            <span>
              The purpose of these T&C is to establish the terms and conditions
              that will govern the use and services provided by Nemuru through
              the Nemuru platform (the <strong>"Platform"</strong>), accessible
              through
              <a href="http://www.nemuru.com">www.nemuru.com</a>, as well as its
              subdomains and/or directories and/or mobile applications and/or
              any other device.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Validation</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Validation Process: </strong>
            </h4>
            <span>
              Prior to the formalization of these T&C and during their validity,
              the User must provide Nemuru with all documentation or information
              requested for Nemuru, and, if applicable, any third party
              designated by Nemuru, to carry out a due diligence process of the
              User, to the extent that Nemuru considers appropriate or
              convenient (the &nbsp;
              <strong>"Validation Process"</strong>). Nemuru may provide the
              corresponding Lenders with the information provided by the User
              during the Validation Process, so that, if applicable, Nemuru or
              the Lenders can comply with their obligations in terms of
              preventing money laundering and terrorist financing or any other
              Applicable Legislation. Likewise, Nemuru may obtain additional
              information about the User from external sources.
            </span>
          </li>
          <li>
            <h4>
              <strong>Registration: </strong>
            </h4>
            <span>
              Nemuru may require the User, to use the Platform and any of its
              functionalities or Services provided by Nemuru, to create their
              own personal account (the&nbsp; <strong>"Account"</strong>), for
              which they must provide certain personal information, which will
              always be treated in accordance with Nemuru's Privacy Policy. This
              Account will be personal, and its access data strictly
              confidential, so the User will be fully responsible for the
              activity carried out in their Account and Nemuru will in no case
              be responsible for any loss or damage that the User may suffer as
              a result of another person using the Account and/or accessing or
              using the content provided therein. Similarly, the User will be
              responsible for any loss or damage caused by the use of their
              Account, regardless of whether it is being used by a third party.
              To maintain control over the Account and prevent anyone from
              accessing it, the User must maintain control over the devices used
              to access the service and not reveal the password or payment
              method details associated with the Account to anyone. The User is
              responsible for updating and maintaining the accuracy of the
              information provided to Nemuru regarding the Account. If any
              unauthorized use of the Account is discovered or suspected, Nemuru
              may cancel or block the same against identity theft or other
              fraudulent activities.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Services</strong>
        </h3>
        <ol>
          <li>
            <span>
              The purpose of the Platform is to offer intermediation services
              (the&nbsp;
              <strong>"Services"</strong>), which allow the User the possibility
              of opting for financing (the &nbsp; <strong>"Financing"</strong>),
              to be granted by an independent lender (the &nbsp;{" "}
              <strong>"Lenders"</strong>), for the purchase of goods or
              contracting of services from a professional or company (the &nbsp;{" "}
              <strong>"Merchants"</strong>).
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Lenders and Financing Process</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Financing Conditions: </strong>
            </h4>
            <span>
              The Lender who may grant the Financing and who will be detailed in
              the proposal will be determined based on the agreements that
              Nemuru had in force at any given time. The conditions of the
              financing to be granted by the Lender will be those provided at
              any given time and will be detailed in the Financing offer sent to
              the User.
            </span>
          </li>
          <li>
            <h4>
              <strong>Loan Proposal: </strong>
            </h4>
            <span>
              After reviewing the documentation or information provided, the
              Validation Process will be carried out by both Nemuru and the
              relevant Lender. If the Validation Process is satisfactory, the
              User will be sent the Financing proposal along with the loan
              proposal (the &nbsp;
              <strong>"Loan Proposal"</strong>). If the Validation Process is
              not passed, this will be notified, and the User will not be able
              to opt for the Financing. In any case, if it is decided not to
              grant the Financing, the User will not be entitled to any
              compensation, and neither Nemuru nor the Lender will be obliged to
              grant the Financing or pay any amount to the User as a result of
              this.
            </span>
            <p>
              For clarification purposes, the acceptance of the User's
              registration application or the sending of any documentation by
              Nemuru does not imply, in any case, the automatic acceptance by
              the Lender of the initially proposed financing offer.
            </p>
          </li>
          <li>
            <h4>
              <strong>Loan Agreement: </strong>
            </h4>
            <span>
              After the Loan Proposal is agreed upon by the Lender, the relevant
              information will be made available to the User in accordance with
              applicable regulations. This information will be made available to
              the User by Nemuru or the Lender, as previously agreed between the
              latter. Subsequently, the Lender and the User will sign the loan
              agreement (<strong>"Loan Agreement"</strong>). The Loan Agreement
              must be signed by the User and the Lender through the means agreed
              between Nemuru and the Lender. In any case, it will likely be
              formalized:
            </span>
            <ul>
              <li>
                Through the Platform and using the electronic signature system
                that Nemuru will make available to the User and the Lender.
              </li>
              <li>Through the electronic platform used by the Lender.</li>
            </ul>
          </li>
          <li>
            <h4>
              <strong>Disbursement: </strong>
            </h4>
            <span>
              Once the Merchant has communicated the start of the services or
              the sale of the products, and similarly, the User has confirmed
              the start of the service or the sale of the product, the amount
              corresponding to the financing will be disbursed, following the
              terms set out in the Loan Agreement.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Right of Withdrawal</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>
                Exercise of the right of withdrawal from the Service provided by
                Nemuru:
              </strong>
            </h4>
            <span>
              The User will have the right to exercise their right of withdrawal
              regarding the Services to be provided by Nemuru under these T&C in
              accordance with the applicable regulations at any given time.
            </span>
          </li>
          <li>
            <h4>
              <strong>
                Exercise of the right of withdrawal from the Loan Agreement:{" "}
              </strong>
            </h4>
            <span>
              For this purpose, the User has a right of withdrawal within
              fourteen (14) calendar days following the formalization of the
              contract, without any reason and without penalty. To exercise the
              right of withdrawal, a withdrawal form is available to the User on
              the Platform. The form is to request the withdrawal of the
              services provided by Nemuru as an intermediary for the loan or
              Financing request being made by the User. It is a formal document,
              as it is a sworn statement of the data and the User's request. It
              is important to note that the form is not intended to end any
              relationship with the financial entity or the Lender if the credit
              has been granted. In that case, the process is different, and the
              User should contact Nemuru using the contact details provided in
              this document.
            </span>
            <p>
              The User releases Nemuru from any liability arising from the
              incorrect use of the withdrawal form as indicated in this clause,
              waiving any claim against Nemuru for it.
            </p>
            <p>
              In any case, the use of the withdrawal form is not mandatory, as
              withdrawal can be made by any legally accepted means. In case of
              any doubt, the User should contact Nemuru.
            </p>
          </li>
          <li>
            <h4>
              <strong>
                Exercise of the right of withdrawal from the Service provided by
                Nemuru:{" "}
              </strong>
            </h4>
            <span>
              In accordance with the applicable regulations, the User will have
              a period of fourteen (14) calendar days to withdraw from the Loan
              Agreement, notifying the Lender by any means that allows proof
              without stating the reasons and without any penalty. For
              clarification purposes, it is stated that the right to withdraw
              from the Loan Agreement does not imply, in any way, the right to
              withdraw from the service contract that the User may have signed
              with the Merchant or with Nemuru, which will be governed by its
              specific regulations.
            </span>
            <p>
              The User releases Nemuru from any liability arising from Nemuru's
              actions as indicated in this clause, waiving any claim against
              Nemuru for it.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Duration and Termination</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Duration: </strong>
            </h4>
            <span>
              These T&C will come into effect on the date of their formalization
              and will have an indefinite duration.
            </span>
          </li>
          <li>
            <h4>
              <strong>Termination: </strong>
            </h4>
            <span>
              In any case, these T&C will be terminated and become null and void
              in the following scenarios:
            </span>
            <ul>
              <li>
                By mutual agreement between the Parties, formalized expressly
                and in writing;
              </li>
              <li>
                At the choice of either Party, without any justification, with a
                minimum notice of ten (10) days;
              </li>
              <li>
                At the choice of the non-defaulting Party, for the substantial
                breach by the other Party of any of the material obligations
                established in these Conditions, except when the breach is
                remediable and is remedied within five (5) calendar days
                following the date on which the defaulting Party is notified and
                required to remedy it. If the breach is not remedied within this
                period, the notifying Party may terminate these Conditions by
                written notice to the defaulting Party and claim any damages
                that may arise;
              </li>
              <li>
                Immediately, in the event that Nemuru has a suspicion or
                indication of money laundering and/or terrorist financing or any
                other activity contrary to the Applicable Legislation concerning
                the User, as well as in the event of a situation related to the
                User that may have a serious negative impact on the reputation
                and image of Nemuru or the Lenders; and
              </li>
              <li>
                Immediately, in the event that the User does not accept the new
                terms and conditions of these T&C notified by Nemuru in
                accordance with the provisions of clause 15.9 below.
              </li>
            </ul>
          </li>
          <li>
            <h4>
              <strong>Effects of termination or resolution: </strong>
            </h4>
            <span>
              The termination and/or resolution of these T&C will be without
              prejudice to the rights and obligations of the Parties acquired
              before such termination. In case of termination and/or rescission,
              the following regime will apply:
            </span>
            <ul>
              <li>
                The automatic cessation of the Services and the impossibility of
                using the Platform and benefiting from the Services by the User;
              </li>
              <li>
                The User must immediately pay Nemuru any amount pending payment
                before the termination of these T&C and, in any case, the
                consideration previously paid will not be refundable, and the
                User will not be able to request a refund of the same; and
              </li>
              <li>
                The termination or resolution of these T&C will not affect the
                Loan Agreements previously formalized or any other commitment
                assumed by the User in the context of the Financing with the
                Lender(s), without prejudice to the obligations and
                responsibilities incurred, if any, towards Nemuru and the
                Lenders under these T&C; and
              </li>
              <li>
                The obligations, commitments, or agreements of the Parties
                provided for in these T&C that, by their nature, must continue
                in force after their termination will remain in effect,
                including but not limited to the obligations (including amounts
                pending payment) assumed by the User in the context of the
                Financing or under these T&C (whether assumed with Nemuru or
                with the Lender), or the obligations or provisions set out in
                clauses 6.3, ‎7, ‎8, ‎9, ‎10, ‎11, ‎12, ‎13, ‎14, and ‎16 of
                these T&C.
              </li>
            </ul>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Intellectual and Industrial Property Rights</strong>
        </h3>
        <ol>
          <li>
            <h4>
              <strong>Intellectual and industrial property rights: </strong>
            </h4>
            <span>
              Nemuru will own and retain all rights, titles, and interests in
              any intellectual and industrial property rights that it possessed
              prior to these T&C or that it develops during or after their term,
              including but not limited to, all and each of the industrial
              and/or intellectual property rights of the Platform,
              documentation, or materials associated with it, including but not
              limited to any software and its algorithms, codes, procedures,
              ideas, or techniques of any nature, including its content and the
              materialization of the same product or graphic design, text or
              image developed or created by photographic, electrostatic, or
              computer procedures, patents, trademarks, utility models,
              industrial designs, topographies of semiconductor products, and
              any other similar rights (<strong>"Nemuru IP”</strong> or{" "}
              <strong>”IP”</strong>). Except as provided in these T&C, the User
              may not distribute, sell, reproduce, publish, display, perform,
              create derivative works from, or otherwise use the Nemuru IP or
              its licensors without the prior express written consent of Nemuru.
            </span>
          </li>
          <li>
            Except with the express and written permission of Nemuru, the User
            may not (in whole or in part) copy, distribute, reproduce, adapt,
            store, transmit, decipher, decrypt, print, display, commercialize,
            perform, publish or create derivative works, offer for sale, or use
            (except as expressly authorized in these T&C) any part of the Nemuru
            IP. No rights are granted to the User, except those expressly set
            forth in these T&C.
          </li>
          <li>
            Furthermore, the User agrees not to bypass, remove, alter,
            deactivate, degrade, or thwart any of the protections of the
            Platform content or Services; use any robot, spider, scraper, or
            other automated means to access the Platform; decompile, reverse
            engineer, or disassemble any software or other products or processes
            accessible through the Platform or Service; insert any code or
            product or manipulate the Platform content or Services in any way;
            or use any data mining, gathering, or extraction methods.
            Additionally, the User agrees not to upload, post, email, or
            transmit any material designed to interrupt, destroy, or limit the
            functionality of any computer software or hardware or
            telecommunications equipment associated with the Platform or
            Services, including any virus or other computer code, files, or
            programs.
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>License</strong>
        </h3>
        <ol>
          <li>
            <span>
              Subject to these T&C, during the term of these T&C Nemuru grants
              the User a limited, revocable, non-exclusive, non-sublicensable,
              and non-transferable license to use the Nemuru Platform (the{" "}
              <strong>“License”</strong>), subject to and in accordance with
              these T&C. This License is solely to allow you to use the Platform
              and benefit from the Services in the manner permitted by these
              T&C. No license or rights are granted to the User except the
              License and rights expressly granted within the framework of these
              T&C.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Representations and Warranties</strong>
        </h3>
        <ol>
          <li>
            The User represents and warrants to Nemuru that:
            <ul>
              <li>
                They have the legal capacity and sufficient authority to enter
                into or accept these T&C and comply with all their provisions;
              </li>
              <li>
                All information, materials, documents, content provided to
                Nemuru will be truthful and legal and will not violate any legal
                provision or third-party rights and will be kept up-to-date at
                all times;
              </li>
              <li>
                The User will not use the funds originated under the Financing
                to finance any activity or business contrary to Applicable
                Legislation at any time; and
              </li>
              <li>
                The User acknowledges and accepts Nemuru's right to terminate
                these T&C immediately if the circumstances represented in this
                clause change or are altered in any way, and/or Nemuru cannot
                guarantee the application of sanctions policy, compliance with
                Applicable Legislation, or even compliance with requirements
                recommended by various national or international bodies to which
                Nemuru has decided to adhere for these purposes.
              </li>
            </ul>
          </li>
          <li>
            <span>
              In case of breach or inaccuracy of the representations and
              warranties detailed in this clause, the regime provided in clause
              ‎10 will apply, without prejudice to any other rights that the
              Parties may exercise in accordance with these T&C or Applicable
              Legislation.
            </span>
            <p>
              To enable Nemuru to comply adequately with regulations, the User
              agrees to respect the rules and procedures established or that may
              be established in the future by Nemuru, providing any information
              or documentation required under the application of such rules and
              procedures.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Liability and Breach</strong>
        </h3>
        <ol>
          <li>
            <span>
              Without prejudice to the provisions of clause ‎11 below, each
              Party shall indemnify and hold the other Party harmless from any
              damages and losses they may suffer as a result of (i) any breach
              of their respective obligations under these T&C; and (ii) any
              breach or inaccuracy of the representations and warranties made
              under the previous clause.
            </span>
            <p>
              The provisions of the preceding paragraph are without prejudice to
              any other right or consequence provided for in these T&C, and to
              the right of the complying Party to terminate these T&C in
              accordance with their provisions.
            </p>
            <p>
              The liability of either Party for any breach of these T&C will
              entitle the other Party to claim damages and losses incurred and
              to demand in any case the fulfillment of these T&C.
            </p>
          </li>
          <li>
            <span>
              Finally, Nemuru reserves the exclusive right to defend directly or
              through a third party any claim, demand, or proceeding of any
              kind, under which Nemuru may become entitled to any kind of
              indemnification under these T&C, without limiting or restricting
              the User's liability. In this case, the User must provide Nemuru
              or any third party designated by Nemuru for this purpose,
              including the Lender, with all reasonably necessary documentation
              for the above actions, as well as cooperate with Nemuru and any
              third party designated for this purpose by Nemuru, including the
              Lender, on reasonable terms.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Disclaimer or Limitation of Liability</strong>
        </h3>
        <ol>
          <li>
            <span>
              The Parties acknowledge and accept that Nemuru assumes no
              responsibility and/or liability arising from the Financing and/or
              any other aspect or incident that may occur in the context of the
              granting of the Financing, nor arising from the purchase of the
              product or provision of the service of the Commerce financed by
              the Lender to the User.
            </span>
            <p>
              In line with the above paragraph, neither Nemuru nor any other
              entity in its group of companies will be responsible in any case
              for the process, information, disbursement of the Financing,
              documentation, content, among others, of the screens and legal
              notices or legal texts of the Lender or the Commerce or related to
              the Financing, the purchase and sale of products or contracting of
              financed services, or any other breach of Applicable Legislation
              by the Lender and/or the Commerce. Additionally, Nemuru will not
              be responsible for the custody of the User's online banking
              credentials, transferring such information to a payment account
              information provider, who will be responsible for safeguarding and
              protecting such information. For this purpose, only tokenized
              online banking credentials will be retained, and no information
              relating to credit cards or bank account numbers will be retained.
            </p>
          </li>
          <li>
            <span>
              In addition to the provisions of the previous clause, the
              Services, Nemuru Platform, and all information, products, and
              services provided through the Nemuru Platform are provided "as is"
              and "as available", and Nemuru does not guarantee that the Nemuru
              Platform or Services will be secure, uninterrupted, accurate, or
              error-free, or that your information will be secure, and to this
              end, the User expressly waives all express or implied warranties
              of any kind, including, but not limited to, implied warranties of
              accuracy or reliability, validity, availability, suitability, or
              completeness of any information, content or data provided through
              the Nemuru Platform and, therefore, in no case will Nemuru be
              liable for any claim, loss, damage, liability, cost or expense of
              any kind, whether direct or indirect (including damages for lost
              profits, loss of income, benefits, data, use, goodwill, or other
              intangible losses, reputational) or any other damage of any kind
              related to or caused by access or use of the Nemuru Platform or
              Services.
            </span>
          </li>
          <li>
            <span>
              Finally, to the maximum extent permitted by Applicable
              Legislation: (a) neither Nemuru nor any entity in its group of
              companies will be liable for any damages of any kind arising in
              any way from the use or inability to use the Services or Nemuru
              Platform, its content or materials, including, without limitation,
              damages caused by or arising from the use by the User of any
              information or material obtained through the Nemuru Platform, or
              resulting from errors, omissions, interruptions, deletions of
              files or email messages, errors, defects, viruses, delays in
              operation or transmission, or any failure of performance, whether
              resulting or not from acts of God, communication failures, theft,
              destruction or unauthorized access to Nemuru's records, programs
              or services; and (b) Nemuru's total liability, whether
              contractual, non-contractual, or for warranty (including
              negligence), product liability, strict liability or liability
              arising from any other legal principle, in connection with the use
              or inability to use the Services or Nemuru Platform, will not
              exceed in any case the amount paid by the User under the Service
              that generated the damage or harm, if any. To the extent that
              Applicable Legislation prevents the limitation of such liability,
              Nemuru will limit its liability to the fullest extent permitted by
              Applicable Legislation.
            </span>
            <li>
              <span>
                The provisions set forth in this clause will remain in effect
                after the termination or resolution of these Conditions.
              </span>
            </li>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Data Protection</strong>
        </h3>
        <ol>
          <li>
            <span>
              User data processing will be governed in accordance with the
              Privacy Policy, which describes information practices, including
              the types of information Nemuru receives and collects from the
              User, as well as details on how this information is used and
              shared, and the User's rights regarding the processing of
              information about the User. The Privacy Policy establishes the
              legal basis for the processing of personal information about the
              User, including, among others, the collection, use, processing,
              and distribution of such information, as well as the transfer and
              processing of such information where we have or use facilities,
              service providers, affiliated companies, or partners, regardless
              of where the User accesses the Platform.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Confidentiality</strong>
        </h3>
        <ol>
          <li>
            <h4>Confidentiality: </h4>
            <span>
              The User agrees to: (a) protect and not disclose information made
              available by Nemuru that is identified as confidential or that
              reasonably should be considered confidential; (b) use this
              information only to fulfill its obligations under these T&C; (c)
              not remove any copyright notice, trademark notice, and/or any
              other proprietary legend established or contained in any
              confidential information; and (d) promptly destroy or return to
              Nemuru all such information when these T&C terminate (and, at
              Nemuru's request, confirm such destruction in writing). This
              clause covers all confidential information, regardless of when the
              User receives it.
            </span>
            <p>
              The obligations under this clause will remain in full force and
              effect after the termination or resolution of these T&C, as long
              as the confidential information remains secret and confidential.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Notifications</strong>
        </h3>
        <ol>
          <li>
            <span>
              All notices, notifications, consents, and other communications
              required or permitted under these T&C will be made in writing and
              in Spanish, and in a reliable manner (providing evidence of their
              receipt and reading). In particular, all notices, notifications,
              consents, and other communications will be sent to the following
              address:
            </span>
            <div style={{ paddingTop: "8px" }}>
              <strong>Nemuru: </strong>
              <div>Attention: Nemuru Support</div>
              <div>
                Address: Palau de Mar Building, Plaza Pau Vila, number 1, 1st
                floor, sector AD, office 1AD, Barcelona
              </div>
              <div>Email: hola@nemuru.com</div>
              <div>Phone: +34 932 200 612</div>
            </div>
            <div style={{ paddingTop: "8px" }}>
              <strong>User: </strong>
              Email and/or postal address provided by the User during the
              Platform registration process. It will be considered that the User
              has received all communications sent to these addresses, even if
              it is no longer current.
            </div>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Miscellaneous</strong>
        </h3>
        <ol>
          <li>
            <h4>Professional Liability Insurance Policy: </h4>
            <span>
              Nemuru holds the professional liability insurance policy
              PI-61693020M0, contracted through the subscription agency Dual
              Ibérica Riesgos Profesionales S.A.U. on behalf of Liberty Mutual
              Insurance Europe SE and Lloyd’s Insurance Company S.A.
            </span>
          </li>
          <li>
            <h4>Quality and Ethical Codes: </h4>
            <span>
              Nemuru is an entity adhered to Confianza Online (Non-profit
              Association), registered in the National Register of Associations
              Group 1, Section 1, national number 594400, CIF G85804011, Calle
              la Palma 59, Bajo A., 28015 Madrid (Spain). For more information:{" "}
              <a href="http://www.confianzaonline.es" target="_blank">
                www.confianzaonline.es
              </a>
              .
            </span>
            <p>
              These T&C are governed by Spanish law. Likewise, in compliance
              with the Alternative Dispute Resolution Law, we inform consumers
              that, as an adhered entity and under the terms of the Ethical
              Code, users may resort to Confianza Online for the alternative
              resolution of possible disputes through the Complaint Form.
            </p>
            <p>
              If these disputes concern electronic transactions with consumers,
              or data protection issues related to this area, claims will be
              resolved by the Mediation Committee of Confianza Online,
              accredited for alternative dispute resolution in consumer matters.
              If the claims concern digital advertising, or data protection
              related to this area, they will be submitted to the Advertising
              Jury of AUTOCONTROL.
            </p>
            <p>
              In addition, Users are reminded that they can access the European
              Union's online dispute resolution platform via the following link:{" "}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank">
                EU Online Dispute Resolution Platform
              </a>
              .
            </p>
          </li>
          <li>
            <h4>Data Access: </h4>
            <span>
              The User authorizes and accepts that Nemuru may connect to or
              access directly or through any third party designated by Nemuru to
              data derived from the Services, for the purpose of collecting,
              aggregating, compiling, and using such data as Nemuru deems
              appropriate, including quality initiatives, benchmarking,
              information services, or Service improvement, among others. Data
              collected or gathered by Nemuru will be used, during and after the
              resolution or termination of these T&C, always maintaining the
              same level of confidentiality regarding the User.
            </span>
          </li>
          <li>
            <h4>Subcontracting: </h4>
            <span>
              Nemuru may subcontract any work or Service to be performed under
              this document. In any case, Nemuru will remain obligated to duly
              and timely fulfill any subcontracted obligation under this
              document.
            </span>
          </li>
          <li>
            <h4>Headings and Titles: </h4>
            <span>
              The headings and titles of this document are included solely for
              ease of reference and shall not in any manner describe the content
              of the corresponding Clauses or represent commitments, terms, or
              conditions of this document.
            </span>
            <p>
              If any provision of this document is determined to be invalid or
              unenforceable in whole or in part, for any reason present or
              future, such invalidity or unenforceability shall not affect the
              enforceability of any other remaining provisions hereof. This
              document shall be construed as if such invalid or unenforceable
              provisions had never been contained herein. For these purposes,
              the document shall cease to be valid exclusively with respect to
              the null or invalid provision, and none of the remaining parts or
              provisions of this document shall be null, invalid, prejudiced, or
              affected by such nullity or invalidity, unless, for the Services
              to be essential, it would have to affect this document as a whole.
            </p>
          </li>
          <li>
            <h4>Entire Agreement: </h4>
            <span>
              This document and its appendices, if any, constitute the entire
              agreement between the Parties in relation to its subject matter
              and supersedes any prior agreements, written or oral, existing
              between the Parties regarding such matter.
            </span>
          </li>
          <li>
            <h4>Waiver of Actions: </h4>
            <span>
              The waiver or non-exercise of rights by any of the Parties under
              this document shall not be deemed a waiver or limitation of any
              other rights or any future rights. Any waiver must be made in
              writing and expressly accepted by the Party to whom it is
              attributed.
            </span>
          </li>
          <li>
            <h4>Assignment: </h4>
            <span>
              The User may not assign or transfer its rights or obligations
              under this document, in whole or in part, to any third party
              without the prior express written consent of Nemuru. Nemuru may
              assign its rights and obligations under this document without the
              need to obtain the consent of the User.
            </span>
          </li>
          <li>
            <h4>Modifications: </h4>
            <span>
              Nemuru may modify, add, or delete this document and the content of
              the Platform at any time and in its sole and absolute discretion.
              In any case, Nemuru will notify before any changes to these T&C
              that remain applicable to Users. If the User does not agree with
              the new conditions, they must cease access and use of the Platform
              and Services. The use and access to the Platform and/or Services
              after any modification of this agreement shall be deemed implicit
              acceptance of all modifications.
            </span>
          </li>
          <li>
            <h4>Force Majeure: </h4>
            <span>
              Neither Party shall be liable for any failure or delay in the
              performance of its obligations under this document for any cause
              beyond the reasonable control of such Party, including but not
              limited to power outages, failure of Internet service providers,
              failure due to Internet interruption (including, without
              limitation, denial of service attacks), riots, insurrection, acts
              of terrorism, war (or similar), fires, floods, pandemics,
              earthquakes, explosions, and other acts beyond the control of the
              Parties.
            </span>
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>Applicable Law and Jurisdiction</strong>
        </h3>
        <ol>
          <li>
            <span>
              These T&C and the access and use of the Platform and Services
              shall be exclusively governed by Spanish law, expressly excluding
              the application of any other rules or legislation that may become
              applicable.
            </span>
          </li>
          <li>
            <span>
              Any dispute, controversy, conflict, or claim arising from the
              interpretation or execution of these T&C (including the Privacy
              Policy and Cookie Policy), or directly or indirectly related to
              the use of the Platform or the provision of the Services, shall be
              exclusively submitted to the Courts and Tribunals of the City of
              Barcelona (Spain).
            </span>
          </li>
        </ol>
      </li>
    </ol>
  </div>
);
